import React from "react";
import { styled } from "styled-components";
import { Colors } from "../../styles";
import { rem } from "../../utils";
const Description = styled.span `
  margin-top: ${rem(4)};
  font-size: ${rem(14)};
  color: ${Colors.PROFILE_RED_2024};
  line-height: ${rem(24)};
`;
const Header = styled.span `
  font-size: ${rem(16)};
  font-weight: 500;
  line-height: ${rem(24)};
  display: flex;
  align-items: center;
  justify-content: center;
`;
const IconContainer = styled.span `
  margin-right: ${rem(16)};
  display: block;
  svg {
    width: ${rem(24)};
    height: auto;
    display: block;
  }
`;
const StyledModalDialogItem = styled.button `
  border: 1px solid ${Colors.GRAY};
  box-sizing: border-box;
  border-radius: 5px;
  padding: ${rem(14)} ${rem(20)};

  background: ${Colors.WHITE};
  display: flex;
  flex-direction: column;
  width: 100%;
  text-align: left;

  color: ${Colors.BLACK};

  &:not([disabled]) {
    cursor: pointer;
  }

  &:disabled {
    background: ${Colors.GRAY_LIGHT};
    color: ${Colors.GRAY_DARK};
    ${Description} {
      font-style: italic;
    }
  }
`;
export const ModalDialogItem = ({ item, onItemClick, ...buttonProps }) => {
    const Icon = item.icon;
    const onClickHandler = () => {
        if (onItemClick) {
            onItemClick(item.target);
        }
    };
    return (React.createElement(StyledModalDialogItem, { disabled: item.disabled, type: "button", onClick: onClickHandler, ...buttonProps },
        React.createElement(Header, null,
            Icon && (React.createElement(IconContainer, null,
                React.createElement(Icon, null))),
            item.label),
        React.createElement(Description, null, item.info)));
};
export default ModalDialogItem;
//# sourceMappingURL=MenuDialogItem.js.map